// extracted by mini-css-extract-plugin
module.exports = {"comp":"ProductNav_comp__ln08I"};